import React from "react"
import "./ContactForm.scss"

const ContactForm = () => (
  <div className="w-form contact-form">
    <form
      id="email-form"
      name="email-form"
      data-name="Email Form"
      method="post"
      action="https://2o60o2o7ze.execute-api.eu-west-2.amazonaws.com/prod"
    >
      <div className="input-wrapper">
        <div className="input-wrap">
          <label htmlFor="First-Name">First Name</label>
          <input
            type="text"
            className="input w-input"
            maxLength="256"
            name="First-Name"
            data-name="First Name"
            id="First-Name"
            required
          />
        </div>
        <div className="input-wrap right">
          <label htmlFor="Last-Name">Last Name</label>
          <input
            type="text"
            className="input w-input"
            maxLength="256"
            name="Last-Name"
            data-name="Last Name"
            id="Last-Name"
            required
          />
        </div>
      </div>
      <div className="input-wrapper">
        <div className="input-wrap">
          <label htmlFor="Email">Email</label>
          <input
            type="email"
            className="input w-input"
            maxLength="256"
            name="Email"
            data-name="Email"
            id="Email"
            required
          />
        </div>
        <div className="input-wrap right">
          <label htmlFor="Phone">Phone</label>
          <input
            type="tel"
            className="input w-input"
            maxLength="256"
            name="Phone"
            data-name="Phone"
            id="Phone"
            required
          />
        </div>
      </div>
      <div className="input-wrapper">
        <div className="input-wrap">
          <label htmlFor="Business-name">Business Name</label>
          <input
            type="text"
            className="input w-input"
            maxLength="256"
            name="Business-name"
            data-name="Business name"
            id="Business-name"
            required
          />
        </div>
        {/* <!-- <div className="input-wrap right"><label htmlFor="Options">Option</label><select id="Options" name="Options" data-name="Options" className="input w-select"><option value="">Select one...</option><option value="First">First Choice</option><option value="Second">Second Choice</option><option value="Third">Third Choice</option></select></div> --> */}
      </div>
      <label htmlFor="Message-title">Message Title</label>
      <input
        type="text"
        className="input w-input"
        maxLength="256"
        name="Message-title"
        data-name="Message-title"
        id="Message-title"
        required
      />
      <label htmlFor="Message">Message</label>
      <textarea
        data-name="Message"
        maxLength="5000"
        id="Message"
        name="Message"
        className="input area w-input"
        required
      ></textarea>
      <div class="form-check">
        <input class="form-check-input " type="checkbox" name="subscribe" id="flexCheckDefault" />
        <label class="form-check-label" for="flexCheckDefault">
          Please click to subscribe and receive newsletters.
        </label>
      </div>
      <br />

      <button type="submit" data-wait="Please wait..." className="btn w-button">
        Submit
      </button>
    </form>
    <div className="w-form-done">
      <div>Thank you! Your submission has been received!</div>
    </div>
    <div className="w-form-fail">
      <div>Oops! Something went wrong while submitting the form.</div>
    </div>
  </div>
)

export default ContactForm
